import { useEffect, useRef, useState, useCallback } from "react";
import st from "@/styles/Ui.module.scss";
import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import TickIcon from "@/svg/TickIcon.tsx";

const NoConnection = () => {
    const [is_connected, set_is_connected] = useState(true);
    const [show_listener, set_show_listener] = useState(false);
    const interval_ref = useRef<any>(null);
    const ref = useRef<any>(null);
    const { t } = useTranslation();
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    // Memoize the handler function to prevent unnecessary re-renders or re-creations
    const show_listener_handler = useCallback((x: boolean) => {
        set_show_listener(x);
    }, []);
    
    useEffect(() => {
        if (show_listener) {
            interval_ref.current = setInterval(async () => {
                
                if(debug === "true") console.info("setInterval NoConnection")
                
                try {
                    const response = await fetch(window.location.origin, {
                        method: 'HEAD',
                        mode: 'no-cors',
                    });
                    
                    if (response.ok) {
                        if (ref.current) {
                            ref.current.classList.add(st.succeded);
                            
                            let timeout = setTimeout(() => {
                                
                                if(debug === "true") console.info("setInterval NoConnection")
                                
                                set_is_connected(true);
                                ref?.current?.classList.remove(st.succeded);
                                set_show_listener(false);
                                clearTimeout(timeout);
                            }, 2000);
                        }
                        
                        clearInterval(interval_ref.current);
                    } else {
                        set_is_connected(false);
                    }
                } catch (error) {
                    set_is_connected(false);
                }
            }, 5000);
        }
    }, [show_listener]);
    
    useEffect(() => {
        // Register the event listener
        eventEmitter.on(CommonClass.CustomEvents.no_connection_listener_show, show_listener_handler);
        
        return () => {
            clearInterval(interval_ref.current);
            eventEmitter.off(CommonClass.CustomEvents.no_connection_listener_show, show_listener_handler);
        };
    }, [show_listener_handler]);
    
    return !is_connected && (
        <div ref={ref} className={clsx(st.no_connection)}>
            <div className={st.inner_not_connected}>
                <CircularProgress color={"inherit"} size={16} />
                <span>{t("no_connection")}</span>
            </div>
            
            <div className={st.inner_succeded}>
                <TickIcon />
                <span>{t("connection_success")}</span>
            </div>
        </div>
    );
};

export default NoConnection;
